import React from 'react';
import './App.css';


import AllRoutesComponent from './routes/routes.component'


function App() {
  return (
    <div className="App">
      <AllRoutesComponent/>
    </div>
  );
}

export default App